import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {animalBrowserAction, CreateAnimalListAction} from '../action';
import {getCabTableInfo} from './get-table-info';

const te = t('animalBrowser');

function* execute({payload: {name, animalType}}: CreateAnimalListAction): SagaIterator {
    yield* put(formHelpers.startSubmit('createAnimalList'));

    const {code, module} = getCabTableInfo(animalType);

    const response = yield* call(Api.validateAnimalList, {id: null, name, module, code});

    const title = te('createAnimalList');

    if (response.isSuccess) {
        const storingResponse = yield* call(Api.createAnimalListFromSession, {module, code, name});
        yield* put(formHelpers.stopSubmit('createAnimalList'));

        if (storingResponse.isSuccess) {
            yield* put(animalBrowserAction.getAnimalLists(animalType, true));
            yield* put(showSuccess(title, te('animalListCreated'), false, 'createAnimalList'));
        } else {
            yield putAll(showBeError(storingResponse, title, {includeFieldErrors: true}));
        }
    } else if (response.isBadRequest) {
        yield* put(formHelpers.stopSubmit('createAnimalList'));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit('createAnimalList', extractFormErrorsFromResponse(response)));
    }
}

/**
 * Creates a saved animal list from the current selection.
 *
 * @returns The saga watcher for `CREATE_ANIMAL_LIST`.
 */
export function* createAnimalListSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/CREATE_ANIMAL_LIST', execute);
}
